export default {
  state: {
    queryCondition: null,
    isIn: false
  },
  mutations: {
    isIn(state, data){
      state.isIn = data;
    },
    saveWarningConition(state, data){
      state.queryCondition = data;
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/warningStore.js